__turbopack_context__.v({
  "body": "styles-module-scss-module__ZWXXwG__body",
  "brandBar": "styles-module-scss-module__ZWXXwG__brandBar",
  "coupons": "styles-module-scss-module__ZWXXwG__coupons",
  "iconContainer": "styles-module-scss-module__ZWXXwG__iconContainer",
  "itemCard": "styles-module-scss-module__ZWXXwG__itemCard",
  "price": "styles-module-scss-module__ZWXXwG__price",
  "priceBar": "styles-module-scss-module__ZWXXwG__priceBar",
  "proxies": "styles-module-scss-module__ZWXXwG__proxies",
  "region": "styles-module-scss-module__ZWXXwG__region",
  "removeButton": "styles-module-scss-module__ZWXXwG__removeButton",
  "share": "styles-module-scss-module__ZWXXwG__share",
  "size": "styles-module-scss-module__ZWXXwG__size",
  "sold": "styles-module-scss-module__ZWXXwG__sold",
  "stats": "styles-module-scss-module__ZWXXwG__stats",
  "text": "styles-module-scss-module__ZWXXwG__text",
  "timeSince": "styles-module-scss-module__ZWXXwG__timeSince",
  "vendor": "styles-module-scss-module__ZWXXwG__vendor",
});
